// extracted by mini-css-extract-plugin
module.exports = {"wrap":"jf","heading":"kf"};